module.exports = __webpack_public_path__ + "assets/333db05fce67b5b387b19d7de8e3f23f.png";